import * as React from 'react';
import cs from 'classnames';
import { message } from '@osui/ui';
import { prefixCls } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const operatorRender = disabled => ({
  tableMutators,
  index
}) => {
  const remove = () => {
    tableMutators.remove(index);
    message.success('删除成功');
  }; // eslint-disable-next-line react/jsx-no-bind


  return /*#__PURE__*/_jsx("span", {
    className: cs(`${prefixCls}-table-operator`, {
      [`${prefixCls}-table-operator-disabled`]: disabled
    }),
    onClick: disabled ? undefined : remove,
    children: "\u5220\u9664"
  });
};
//# sourceMappingURL=es/components/Table/colunmRender.js.map